import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { MatchesModalSchema } from '@/views/sports/components/MatchesModal/styles/MatchesModal.styles';

export const matchesModalStyles: MatchesModalSchema = {
  modalWrapper: { size: 'lg', isCentered: true, scrollBehavior: 'inside' },
  modalContent: {
    bg: 'alpha.500',
    boxShadow: '0px 4px 14px 0px rgba(0, 0, 0, 0.40)',
    color: 'white',
    overflow: 'hidden',
  },
  modalHeader: {
    fontSize: 'lg',
    alignItems: 'center',
    borderBottom: '1px',
    borderColor: 'alpha.800',
    display: 'flex',
    gap: '4',
    justifyContent: 'space-between',
    p: '4',
  },
  closeButton: {
    bg: 'white',
    color: 'alpha.500',
    isRound: true,
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: { bg: 'white' },
  },
  divider: { as: 'div', borderColor: 'alpha.800' },
  modalBody: { p: '0', maxH: '400px' },
  stackWrapper: { spacing: '0' },
  linkWrapper: {
    alignItems: 'center',
    display: 'flex',
    gap: '3',
    justifyContent: 'space-between',
    p: '3',
    _hover: { bg: 'blackAlpha.400', textDecoration: 'none' },
  },
  flexSportName: {
    align: 'center',
    fontSize: 'xs',
    fontWeight: 'bold',
    gap: '1.5',
    color: 'white',
  },
  iconSportName: { fontSize: '2xl', color: 'alpha.400' },
  hStack: { spacing: '1' },
  countdown: {
    color: 'inherit',
    fontSize: '9px',
    h: '17px',
    pt: '0',
    sx: {
      '&&': {}, // Reset
      ':not(.state-prior)': { color: 'white' },
    },
  },
  duotoneSgmLogoOverride: {
    h: 'auto',
    w: '9',
  },
  hStackIcon: {
    as: ChevronRight,
    color: 'gray.400',
    fontSize: '2xl',
  },
};
